export default __webpack_public_path__ + "static/media/TaskImageGroup.baa756a7.svg";